import React, { ReactNode } from 'react'
import Button from '@/components/ui/Buttons/Button'
import { MenuButton, MenuButtonOwnerState } from '@mui/base/MenuButton'
import { useTriggerSlotProps } from '@/components/ui/Menu/Menu.hooks'
import { ButtonProps } from '@/components/ui/Buttons/Button/Button'

export type HeaderTriggerProps = {
  children: string
  StartIcon: ReactNode
}

export type ButtonTriggerProps = ButtonProps & {
  component?: React.FC<any>
}

export const ButtonTrigger = ({ children, component = Button, ...props }: ButtonTriggerProps) => {
  const slots = { root: component }

  const slotProps = {
    root: (ownerState: MenuButtonOwnerState) => ({
      isOpen: ownerState.open,
      ...props,
    }),
  }

  return (
    <MenuButton slots={slots} slotProps={slotProps}>
      {children}
    </MenuButton>
  )
}
export const HeaderTrigger = ({ children, StartIcon }: HeaderTriggerProps) => {
  const slots = { root: Button }

  const slotProps = useTriggerSlotProps(StartIcon)

  return (
    <MenuButton slots={slots} slotProps={slotProps}>
      {children}
    </MenuButton>
  )
}
